import {objects, sorting} from "@atttomyx/shared-utils";

export const sortByFileName = (a, b) => {
    return sorting.sortByField(a, b, "fileName");
};

export const isSortable = (order) => {
    return objects.notNullOrUndefined(order) && order >= 0;
};
